(() => {
  const text = JSON.parse(document.getElementById('pm-order-text').textContent);
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency}).format(cents / 100);
  const root = window.Shopify?.routes?.root || '/';
  const properties = values => Object.entries(values || {}).filter(([key,value]) => !key.startsWith('_') && value !== '' && value !== null).map(([key,value]) => `${key}: ${value}`);
  if (!customElements.get('pm-customisation')) customElements.define('pm-customisation', class extends HTMLElement {
    connectedCallback() {
      this.product = JSON.parse(this.dataset.product);
      this.form = this.querySelector('form');
      this.details = this.querySelector('details');
      this.update = this.update.bind(this);
      this.onChange = () => requestAnimationFrame(this.update);
      document.addEventListener('change', this.onChange);
      document.addEventListener('variant:changed', this.onChange);
      this.details.addEventListener('toggle', this.update);
      this.form.addEventListener('submit', event => { if (!this.update()) event.preventDefault(); });
      if (this.querySelector('.errors,[role="status"]')) this.details.open = true;
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('change', this.onChange); document.removeEventListener('variant:changed', this.onChange); }
    update() {
      const form = document.getElementById(this.dataset.productForm);
      const variant = this.product.variants.find(item => String(item.id) === form?.querySelector('[name="id"]')?.value);
      const summary = this.querySelector('[data-pm-specs]');
      if (!summary) return true;
      const submit = this.querySelector('[data-pm-submit]');
      const add = form?.querySelector('[name="add"]');
      const price = document.querySelector('[data-pm-product-price]');
      if (price) price.textContent = variant?.price > 0 ? money(variant.price, this.dataset.currency) : text.price_request;
      if (add && variant && variant.price <= 0) { add.disabled = true; add.querySelector('span').textContent = text.price_request; }
      if (!variant) { submit.disabled = true; summary.value = text.select_variant; return false; }
      const lines = [this.product.title];
      this.product.options.forEach((option,index) => lines.push(`${option}: ${variant.options[index]}`));
      lines.push('', text.custom_terms);
      summary.value = lines.join('\n');
      submit.disabled = false;
      return true;
    }
  });
  if (!customElements.get('pm-cart-deposit')) customElements.define('pm-cart-deposit', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.summary = this.querySelector('[data-pm-specs]');
      if (!this.summary) { this.querySelector('details').open = true; return; }
      this.button = this.querySelector('[data-pm-submit]');
      this.refresh = this.refresh.bind(this);
      this.querySelector('details').addEventListener('toggle', () => { if (this.querySelector('details').open) this.refresh(); });
      this.form.addEventListener('submit', async event => {
        if (this.dataset.demo === 'true') { event.preventDefault(); return; }
        if (this.confirmed) return;
        event.preventDefault();
        if (this.sending) return;
        this.sending = true;
        const valid = await this.refresh();
        this.sending = false;
        if (valid && this.form.reportValidity()) { this.confirmed = true; this.form.requestSubmit(this.button); }
      });
      document.addEventListener('cart:updated', this.refresh);
      if (window.FoxTheme?.pubsub) this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.refresh);
      if (location.hash === '#pm-deposit' || this.querySelector('.errors')) this.querySelector('details').open = true;
      this.refresh();
    }
    disconnectedCallback() { document.removeEventListener('cart:updated', this.refresh); this.unsubscribe?.(); this.controller?.abort(); }
    async refresh() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button.disabled = true;
      try {
        let cart;
        if (this.dataset.demo === 'true') {
          cart = JSON.parse(this.querySelector('[data-pm-demo]').textContent);
        } else {
          const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'},cache:'no-store',signal:this.controller.signal});
          if (!response.ok) throw new Error('cart');
          cart = await response.json();
        }
        if (!cart.items.length || cart.total_price <= 0 || cart.items.some(item => item.final_price <= 0)) throw new Error('cart');
        const currency = cart.currency || this.dataset.currency;
        const lines = [text.deposit_subject];
        cart.items.forEach((item,index) => {
          lines.push('', `${index+1}. ${item.product_title}`);
          (item.options_with_values || []).forEach(option => lines.push(`${option.name}: ${option.value}`));
          lines.push(`${text.sku}: ${item.sku || text.unassigned}`, `${text.variant}: ${item.variant_id}`, `${text.quantity}: ${item.quantity}`, `${text.unit_price}: ${money(item.final_price,currency)}`, `${text.line_total}: ${money(item.final_line_price,currency)}`);
          lines.push(...properties(item.properties), new URL(item.url, location.origin).href);
        });
        const deposit = Math.round(cart.total_price / 2);
        lines.push('', `${text.subtotal}: ${money(cart.total_price,currency)}`, `${text.deposit_amount}: ${money(deposit,currency)}`, `${text.balance}: ${money(cart.total_price-deposit,currency)}`, `${text.currency}: ${currency}`, `${text.cart_note}: ${cart.note || text.none}`, text.freight_note, text.terms, text.mixed);
        this.summary.value = lines.join('\n');
        this.querySelector('[data-pm-error]').hidden = true;
        this.button.disabled = this.dataset.demo === 'true';
        return true;
      } catch(error) {
        if (error.name === 'AbortError') return false;
        this.summary.value = '';
        this.querySelector('[data-pm-error]').hidden = false;
        return false;
      }
    }
  });
  if (!customElements.get('pm-delivery-review')) customElements.define('pm-delivery-review', class extends HTMLElement {
    async connectedCallback() {
      this.output = this.querySelector('output');
      try {
        const response = await fetch(this.dataset.rulesUrl);
        if (!response.ok) throw new Error('rules');
        this.rules = await response.json();
        this.addEventListener('input', () => this.calculate());
        this.calculate();
      } catch { this.output.textContent = this.dataset.error; }
    }
    calculate() {
      const area = this.querySelector('[data-pm-area]').value;
      let sum = 0, highest = 0, count = 0;
      for (const input of this.querySelectorAll('[data-pm-tier]')) {
        const quantity = Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > 100) { this.output.textContent = this.dataset.error; return; }
        const rate = this.rules.rates[area][input.dataset.pmTier];
        sum += rate * quantity;
        if (quantity > 0) highest = Math.max(highest, rate);
        count += quantity;
      }
      this.output.textContent = count ? money(highest + (sum-highest)*this.rules.additionalItemFactor, this.dataset.currency) : this.dataset.empty;
    }
  });
})();
